import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { nok } from "@/lib/format";
import { kFmt, ChartTooltip } from "@/components/finance/chart";
import { Skeleton } from "@/components/ui/skeleton";

export function LiquidityTab({ data, colors }) {
  const bankVal = data?.key_figures?.find((f) => f.key === "bank")?.value;
  const points = (data?.liquidity || []).filter((l) => l.saldo !== null);
  const bankNote = data?.source?.bank_note;
  return (
    <div className="rounded-2xl border border-border/60 bg-card p-5 shadow-sm sm:p-6">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h3 className="font-headings text-base font-bold tracking-tight">Likviditetsutvikling</h3>
          <p className="text-xs text-muted-foreground">Bankinnskudd (kontoklasse 19xx) gjennom året</p>
        </div>
        {data ? (
          <div className="text-right">
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground">Bankinnskudd nå</p>
            <p className="font-headings text-2xl font-extrabold tabular-nums" data-testid="liquidity-current">
              {bankVal == null ? "—" : nok(bankVal)}
            </p>
          </div>
        ) : null}
      </div>
      {!data ? (
        <Skeleton className="h-[320px] w-full rounded-xl" />
      ) : points.length === 0 ? (
        <div className="grid h-[320px] w-full place-items-center rounded-xl bg-muted/30 px-6 text-center" data-testid="likviditet-empty">
          <div>
            <p className="font-headings text-sm font-bold">Bankinnskudd ikke tilgjengelig</p>
            <p className="mt-2 max-w-md text-xs text-amber-600 dark:text-amber-400">
              {bankNote || "Kunne ikke hente banksaldo (19xx) fra regnskapssystemet. Vi viser ikke overskudd som bankinnskudd."}
            </p>
          </div>
        </div>
      ) : (
        <div className="h-[320px] w-full" data-testid="likviditet-chart">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={points} margin={{ top: 10, right: 8, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="liqFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={colors.lime} stopOpacity={0.55} />
                  <stop offset="100%" stopColor={colors.lime} stopOpacity={0.03} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke={colors.grid} vertical={false} />
              <XAxis dataKey="month" tickLine={false} axisLine={{ stroke: colors.grid }} tick={{ fill: colors.axis, fontSize: 12 }} />
              <YAxis tickFormatter={kFmt} tickLine={false} axisLine={false} tick={{ fill: colors.axis, fontSize: 12 }} width={48} />
              <Tooltip content={<ChartTooltip />} />
              <Area type="monotone" dataKey="saldo" name="Saldo" stroke={colors.resultat} strokeWidth={2.5} fill="url(#liqFill)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
